/* Venace homepage sections — tabs + slider arrows (event delegation, safe to include multiple times) */
(function () {
  if (window.__venaceInit) return;
  window.__venaceInit = true;

  function updateArrows(slider) {
    var track = slider.querySelector('.vn-track');
    var prev = slider.querySelector('[data-vn-prev]');
    var next = slider.querySelector('[data-vn-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  function initSliders(root) {
    (root || document).querySelectorAll('[data-vn-slider]').forEach(function (slider) {
      var track = slider.querySelector('.vn-track');
      if (!track || track.__vnBound) return;
      track.__vnBound = true;
      track.addEventListener('scroll', function () { updateArrows(slider); }, { passive: true });
      updateArrows(slider);
    });
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-vn-prev], [data-vn-next]');
    if (arrow) {
      var slider = arrow.closest('[data-vn-slider]');
      var track = slider && slider.querySelector('.vn-track');
      if (!track) return;
      var dir = arrow.hasAttribute('data-vn-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }

    var tab = e.target.closest('[data-vn-tab]');
    if (tab) {
      var wrap = tab.closest('[data-vn-tabs]');
      var id = tab.getAttribute('data-vn-tab');
      wrap.querySelectorAll('[data-vn-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      wrap.querySelectorAll('[data-vn-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-vn-panel') !== id;
      });
      initSliders(wrap);
      wrap.querySelectorAll('[data-vn-slider]').forEach(updateArrows);
    }
  });

  document.addEventListener('DOMContentLoaded', function () { initSliders(); });
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
  if (document.readyState !== 'loading') initSliders();
})();
